export default {
    namespaced: true,
    state: {
        finePrint: [],
    },
    getters: {
        getAll(state) {
            return state.finePrint;
        },
    },
    mutations: {
        setAll(state, finePrint) {
            Object.assign(state, {
                finePrint,
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const finePrint = await context.dispatch('api/request', {
                service: 'finePrint',
                type: 'getAll',
            }, { root: true });

            if (finePrint) {
                context.commit('setAll', finePrint);
            }
        },
    },
};
